var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-date-interval"},[_vm._v("\n\tС\n\t"),_c('i-date-picker'),_vm._v("\n\tПо \n\t"),_c('i-date-picker')],1)}
var staticRenderFns = []

export { render, staticRenderFns }